import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { marker as l10n } from '@biesbjerg/ngx-translate-extract-marker';
import { IShellDisplay, SHELL_DISPLAY } from '@shared/metadata/IShellDisplay';
import {
  NavMenuItem,
  NavMenuItemType,
  NavMenuSection,
  NAV_MENU_ITEM,
} from '@shared/metadata/INavMenuItem';
import { StreamlineIconsModule } from '@shared/icons/streamline-icons.module';
import { OperationCode } from '@core/enum';
import { AlertType } from '@model/notifications';

const shellDisplay: IShellDisplay = {
  route: '/pages/billing',
  navTitleKey: l10n('BILLING.NAV_TITLE'),
  navTitleSvgIcon: 'streamline:common-file-text-cash',
};

const navMenuItem: NavMenuItem = {
  type: NavMenuItemType.SingleItem,
  route: '/pages/billing',
  section: NavMenuSection.SelfServices,
  titleKey: l10n('BILLING.NAV_TITLE'),
  svgIcon: 'streamline:common-file-text-cash',
  operationCode: OperationCode.AccessBilling,
  order: 10,
  alertType: AlertType.BILLING,
};

@NgModule({
  declarations: [],
  imports: [MatIconModule, StreamlineIconsModule],
  providers: [
    { provide: SHELL_DISPLAY, useValue: shellDisplay, multi: true },
    { provide: NAV_MENU_ITEM, useValue: navMenuItem, multi: true },
  ],
})
export class BillingMetadataModule {}
